import "core-js/modules/es.array.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "antd/lib/notification/style";
import _notification from "antd/lib/notification";
import "antd/lib/message/style";
import _message from "antd/lib/message";
import React from 'react';
import * as api from '@services/api';
/**
 * extends component
 *
 * @export
 * @class ComponentExt
 * @extends {React.Component<P, S>}
 * @template P
 * @template S
 */

export class ComponentExt extends React.Component {
  constructor() {
    super(...arguments);
    this.api = api;
    this.$message = _message;
    this.$notification = _notification;
  }

}
/**
 * extends store
 *
 * @export
 * @class StoreExt
 */

export class StoreExt {
  constructor() {
    this.api = api;
    this.$message = _message;
    this.$notification = _notification;
  }

}